/* eslint-disable import/prefer-default-export, consistent-return */
// consistent-return isn't good for this case.
// Redux-form validation should return something only if value isn't valid
// Returning of undefined implicitly looks not so good;
import { isEmpty, isNil } from 'ramda';

export const required = (value) => (value || typeof value === 'number' ? undefined : 'Required');

export const arrayRequired = (value) => {
  if (isNil(value) || isEmpty(value)) {
    return 'Is required';
  }
};

export const lengthFrom = (min) => (value) => {
  if (value.length && value.length < min) {
    return '< min';
  }
};
export const lengthTo = (max) => (value) => {
  if (value.length && value.length > max) {
    return '> max';
  }
};

export const numberFrom = (min) => (value) => {
  if (parseFloat(value) < min) {
    return '< min';
  }
};

export const numberTo = (max) => (value) => {
  if (parseFloat(value) > max) {
    return '> max';
  }
};

export const from1 = lengthFrom(1);
export const from2 = lengthFrom(2);
export const to50 = lengthTo(50);